import * as React from "react";
import { Typography, withStyles } from "@material-ui/core";
import cone from "common/assets/images/cone.png";
import darkMagnifier from "common/assets/images/darkMagnifier.png";
import ModelMapItem, {
  IModelMapView,
} from "modules/modelMap/components/layouts/ModelMapItem";
import i18n from "i18n";
import { FirebaseDocument } from "common/models/FirebaseDocument";
import { ModelMap } from "modules/modelMap/models/ModelMap";

const styles = () => ({
  listContainer: { height: "calc(75vh)", overflowY: "scroll" as any },
  table: {
    display: "table",
    height: "calc((100vh - 68px) * 0.85)",
  },
  tableCell: {
    display: "table-cell",
    verticalAlign: "middle",
    padding: "0 25px",
    textAlign: "center" as any,
  },
  stageTitle: {
    fontFamily: "Roboto",
    fontSize: 14,
    fontWeight: 700,
    color: "rgba(255,255,255,0.87)",
  },
  stageSubtitle: {
    fontFamily: "Roboto",
    fontSize: 11,
    fontWeight: 300,
    color: "rgba(255,255,255,0.67)",
  },
});

const MessageCell = ({ classes, icon, title, message }) => {
  return (
    <div className={classes.table}>
      <div className={classes.tableCell}>
        <img src={icon} />
        <Typography className={classes.stageTitle} component="span">
          {title}
        </Typography>
        <Typography className={classes.stageSubtitle} component="span">
          {message}
        </Typography>
      </div>
    </div>
  );
};

type IProps = {
  classes: any;
  modelMaps: FirebaseDocument<ModelMap>[];
  modelMapsView: IModelMapView[];
  canEditName: boolean;
  showInsertQttButton: boolean;
  showInsertTakeOffButton: boolean;
  showActionButton: boolean;
};

const ModelMapList = ({
  classes,
  modelMaps = [],
  modelMapsView = [],
  showInsertQttButton,
  showInsertTakeOffButton,
  canEditName,
  showActionButton,
}: IProps) => {
  const labels = i18n.modelMaps.menuLateral;

  if (modelMaps === undefined || modelMaps.length === 0) {
    return (
      <MessageCell
        classes={classes}
        icon={darkMagnifier}
        title={labels.noModels}
        message={labels.noModelsSubtitle}
      />
    );
  }

  if (modelMapsView === undefined || modelMapsView.length === 0) {
    return (
      <MessageCell
        classes={classes}
        icon={cone}
        title={labels.noModelSearch}
        message={labels.noModelSearchSubtitle}
      />
    );
  }

  return (
    <div className={classes.listContainer}>
      {modelMapsView.map((model) => (
        <ModelMapItem
          key={model.id}
          modelMap={model}
          showInsertQttButton={showInsertQttButton}
          showInsertTakeOffButton={showInsertTakeOffButton}
          canEditName={canEditName}
          showActionButton={showActionButton}
        />
      ))}
    </div>
  );
};
export default withStyles(styles)(ModelMapList);



// WEBPACK FOOTER //
// ./src/modules/modelMap/components/layouts/ModelMapList.tsx